import path from "path";
import WhatIs from "../pages/Zodiac/WhatIsZodiac";
import Home from "../pages/Home";
import * as links from "./links";
import ZodiacDailyHoroscope from "../pages/Zodiac/ZodiacDailyHoroscope";
import ZodiacCalendar from "../pages/Zodiac/ZodiacCalendar";
import ZodiacLoveCompatibility from "../pages/Zodiac/ZodiacLoveCompatibility";
import ConstellationsQuiz from "../pages/Zodiac/ConstellationsQuiz";
import ZodiacSignQuiz from "../pages/Zodiac/ZodiacSignQuiz";
import WhatIsNumerology from "../pages/Numerology/WhatIsNumerology";
import ListNumbers from "../pages/Numerology/ListNumbers";
import WhatIsTarot from "../pages/Tarot/WhatIsTarot";
import TarotDecks from "../pages/Tarot/TarotDecks";
import RankingOfConstellations from "../pages/Zodiac/RankingOfConstellations";
import ZodiacList from "../pages/Zodiac/ZodiacList";
import MeaningOfNumbers from "../pages/Numerology/MeaningOfNumbers";
import MeaningOfAngelNumbers from "../pages/Numerology/MeaningOfAngelNumbers";
import MasterNumbers from "../pages/Numerology/MasterNumbers";
import IndicatorsLifePath from "../pages/Numerology/IndicatorsLifePath";
import IndicatorsExpression from "../pages/Numerology/IndicatorsExpression";
import IndicatorsName from "../pages/Numerology/IndicatorsName";
import IndicatorsBirthday from "../pages/Numerology/IndicatorsBirthday";
import IndicatorsCompatibility from "../pages/Numerology/IndicatorsCompatibility";
import DailyCard from "../pages/Tarot/DailyCard";
import OneCardTarotReading from "../pages/Tarot/OneCardTarotReading";
import YesNoTarot from "../pages/Tarot/YesNoTarot";
import DailyLoveTarot from "../pages/Tarot/DailyLoveTarot";
export const private_routes = [
  {
    path: links.HOME,
    component: Home,
  },
  {
    path: links.ZODIAC_WHAT_IS,
    component: WhatIs,
  },
  {
    path: links.ZODIAC_LIST,
    component: ZodiacList,
  },
  {
    path: links.ZODIAC_SIGN_QUIZ,
    component: ZodiacSignQuiz,
  },
  {
    path: links.ZODIAC_CONSTELLATIONS_QUIZ,
    component: ConstellationsQuiz,
  },
  {
    path: links.ZODIAC_LOVE_COMPATIBILITY,
    component: ZodiacLoveCompatibility,
  },
  {
    path: links.ZODIAC_CALENDAR,
    component: ZodiacCalendar,
  },
  {
    path: links.ZODIAC_DAILY_HOROSCOPE,
    component: ZodiacDailyHoroscope,
  },
  {
    path: links.ZODIAC_RANKING_OF_CONSTELLATIONS,
    component: RankingOfConstellations,
  },
  {
    path: links.NUMEROLOGY_WHAT_IS,
    component: WhatIsNumerology,
  },
  {
    path: links.NUMEROLOGY_MEANING_OF_NUMBERS,
    component: MeaningOfNumbers,
  },
  {
    path: links.NUMEROLOGY_MEANING_OF_ANGEL_NUMBERS,
    component: MeaningOfAngelNumbers,
  },
  {
    path: links.NUMEROLOGY_MASTER_NUMBERS,
    component: MasterNumbers,
  },
  {
    path: links.NUMEROLOGY_INDICATORS_LIFE_PATH,
    component: IndicatorsLifePath,
  },
  {
    path: links.NUMEROLOGY_INDICATORS_EXPRESSION,
    component: IndicatorsExpression,
  },
  {
    path: links.NUMEROLOGY_INDICATORS_BIRTHDAY,
    component: IndicatorsBirthday,
  },
  {
    path: links.NUMEROLOGY_INDICATORS_NAME,
    component: IndicatorsName,
  },
  {
    path: links.NUMEROLOGY_LIST_NUMBERS,
    component: ListNumbers,
  },
  {
    path: links.NUMEROLOGY_INDICATORS_COMPATIBILITY,
    component: IndicatorsCompatibility,
  },
  {
    path: links.TAROT_WHAT_IS,
    component: WhatIsTarot,
  },
  {
    path: links.TAROT_DECKS,
    component: TarotDecks,
  },
  {
    path: links.TAROT_DAILY_CARD,
    component: DailyCard,
  },
  {
    path: links.TAROT_DAILY_LOVE_TAROT,
    component: DailyLoveTarot,
  },
  {
    path: links.TAROT_YES_NO_TAROT,
    component: YesNoTarot,
  },
  {
    path: links.TAROT_ONE_CARD_TAROT_READING,
    component: OneCardTarotReading,
  },
];
